export default function Background() {
    return (
        <div className="bg" aria-hidden="true">
            <span className="bg-blob bg-blob--a" />
            <span className="bg-blob bg-blob--b" />
            <span className="bg-blob bg-blob--c" />
            <div className="bg-grain" />
        </div>
    );
}
